"use client";

import { StarIcon as StarIconFull } from "@hugeicons-pro/core-solid-rounded";
import { StarIcon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";
import ControlIcon from "./ControlIcon";
import { ControlContainer, type ControlProps } from "./IconContainer";

type Props = ControlProps & {
  isFavourite?: boolean;
};

const GameControlsFavorite: FC<Props> = ({ isFavourite = false, ...props }) => (
  <ControlContainer {...props}>
    <ControlIcon icon={isFavourite ? StarIconFull : StarIcon} />
  </ControlContainer>
);

export { GameControlsFavorite };
